export default class UserCredentials {
    constructor(username, email, password) {
      this.username = username;
      this.email = email;
      this.password = password;
    }
  }